import api from '@/sui/api/api'

function testStat (data, type) {
  return api.post(`/external/stat/${type}`, data)
}

export default {
  testStat: testStat
}
